export default __webpack_public_path__ + "static/media/git_icon.422b5548.webp";